import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { FeatureService } from '../../../../../core/services/feature.service';
import { ProfileService } from '../../../../../core/services/profile.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'ngx-profile',
    templateUrl: './profile.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgxPaginationModule, NgSelectModule],
    styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  selected_data:any
  data:any[]=[]
  user:any
  actions:any
  features:any[]=[]
  permissions:any[]=[]
  permissionsChosen:any[]=[]
  loading=false
  loading2=false
  tag="admin-profiles"
  search_text=""
  searchByRole:any={}

      constructor(
        private featureService:FeatureService, 
        private locService:LocalStorageService, 
        private profileService:ProfileService,
        private toastrService:ToastrService,
        private dialogService:NgbModal,
        private modalService:NgbModal,
        private spinnerService:NgxSpinnerService

        ){
  
      } 
  
    ngOnInit(): void {
      this.all();
      this.getFeatures()
      this.user=this.locService.get(GlobalName.userName);
      this.permissions=this.user.roles[0]?.permissions;
    }
  
    getFeatures(){
      this.featureService.getAllwithRelations().subscribe((res:any)=>{
        this.features=res.data
       
      },
      (err:any)=>{
      AppErrorShow.showError("Gestion des fonctionnalités et interfaces",err)
      })
    }
    all() {
      this.groupCache={}
      this.permissionsChosen=[]
      this.loading2=true;
      this.spinnerService.show()
      this.profileService.getAll().subscribe((res:any)=>{
        this.data=res.roles
        this.permissions=res.permissions
        this.loading2=false;
        this.spinnerService.hide()

      },
      (error:any)=>{
        this.spinnerService.hide()

        this.loading2=false;
      })
    }
  
    getJson(arr:any){
      return JSON.parse(arr)
    }
    checked(el:any){
      this.selected_data=el
    }
  
    
    open(dialog: TemplateRef<any>,el:any) {
      this.selected_data=el
      this.dialogService.open(
        dialog,{size:"lg"});
        
    }

  
  
    store(value:any,ref:any) {
      this.toastrService.info("Opération en cours","Profil")

      this.loading=true;
      value['id']=this.selected_data.id      
     
        this.profileService.store(value).subscribe(
            (res:any)=>{
            this.loading=false;
            this.modalService.dismissAll()
            this.all();
            this.toastrService.success("Droit ajouté au rôle","Profil")

        },
        (err:any)=>{
            this.loading=false;
            AppErrorShow.showError("Gestion des profils",err)

        })
  
  }
  copyStore(value:any,ref:any) {
      this.toastrService.info("Opération en cours","Profil")
      value['id']=this.selected_data.id      

      this.loading=true;     
        this.profileService.copyStore(value).subscribe(
            (res:any)=>{
            this.loading=false;
            this.modalService.dismissAll()
            this.all();
            this.toastrService.success("Droit ajouté au rôle","Profil")

        },
        (err:any)=>{
            this.loading=false;
            AppErrorShow.showError("Gestion des profils",err)

        })
  
  }
  hasPermission(permission:any){
    var check= this.permissions.find((e:any)=>e.name ==permission)
    if(check) return true;
    return false
  }

  revoke(id:any,id2:any){
    this.loading=true;
    if(confirm("Voulez vous retirer ce droit ?")){
      this.toastrService.info("Opération en cours","Profil")
         this.profileService.update({id:id2},id).subscribe(
          (res:any)=>{
          this.loading=false;
          this.all();
          this.toastrService.success("Droit retiré du rôle","Profil")


      },
      (err:any)=>{
          this.loading=false;
          AppErrorShow.showError("Gestion des profils",err)

      })
    }
   
  }


  /**
   * Un role peut porter plusieurs centaines de permissions ; les lister a plat
   * rendait la page inexploitable. On les regroupe par fonctionnalite, le nom
   * d'une permission ayant la forme "action => libelle de la fonctionnalite".
   */
  private groupCache:any={}

  /**
   * Un role peut porter plusieurs centaines de permissions ; les lister a plat
   * rendait la page inexploitable. On les regroupe par fonctionnalite, le nom
   * d'une permission ayant la forme "action => libelle de la fonctionnalite".
   * Le resultat est memorise : sans cela le regroupement etait recalcule a
   * chaque cycle de detection, pour chaque role affiche.
   */
  groupByFeature(permissions:any[], filter:string=''):any[]{
    const key=(permissions?.length ?? 0)+'|'+(filter ?? '')+'|'+(permissions?.[0]?.id ?? '')
    if (this.groupCache[key]) return this.groupCache[key]
    const groups:any={}
    const needle=(filter ?? '').toLowerCase()
    for (const p of permissions ?? []) {
      const label=(p?.name ?? '').split('=>').slice(1).join('=>').trim() || (p?.name ?? '')
      if (needle && !label.toLowerCase().includes(needle) && !(p?.action ?? '').toLowerCase().includes(needle)) continue
      if (!groups[label]) groups[label]={label:label, items:[]}
      groups[label].items.push(p)
    }
    const res=Object.values(groups) as any[]
    this.groupCache[key]=res
    return res
  }

  countPermissions(r:any){
    return (r?.permissions ?? []).length
  }

  countFeatures(r:any){
    return this.groupByFeature(r?.permissions ?? []).length
  }

  searchFor(r:any){
    return this.searchByRole[r?.id] ?? ''
  }

  setSearch(r:any, value:string){
    this.searchByRole[r?.id]=value
  }

  roleLabel(name:string){
    const labels:any={adminsys:'Administrateur système', professeur:'Enseignant', parent:'Parent',
      apprenant:'Apprenant', comptable:'Comptable', rh:'Ressources humaines',
      infirmier:'Infirmier', de:'Directeur des études'}
    return labels[name] ?? name
  }

  getActions(event:any){
    this.actions= JSON.parse(this.permissions.find((el:any)=>el.id==event)?.actions ?? "")
  }

}
